/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-form-field{width:100%}.mat-form-field-disabled .mat-form-field-label{color:#c5c5c5!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mat.field/mat.field.component.scss.ngstyle.js.pre-build-optimizer.js